import React, { FC, useContext, useEffect, useState } from 'react'
import { useLayout } from '../../core'
import { AsideMenu } from './AsideMenu'
import { useSelector } from 'react-redux'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'
import { isEmpty } from 'lodash'
import {settingAssetUrl} from 'src/app/queries/signedMediaUrl'
import { Drawer } from 'antd'
import { ActiveMenuContex } from '../../MasterLayout'

const AsideDefault: FC = () => {
  const { classes } = useLayout()
  const [logo, setLogo] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const activeMenu: any = useContext(ActiveMenuContex)

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData?.['Theme settings']?.forEach((item: any) => {
        if (item?.name === 'mainLogo') {
          setLogo(settingAssetUrl(item))
        }
      })
    }
  }, [settingTypeData])

  const onClose = () => {
    activeMenu.setOpen(false)
  }

  return (
    <Drawer
      closable={false}
      onClose={onClose}
      open={activeMenu.open}
      placement='left'
      width={280}
      bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      {/* Logo header */}
      <div
        style={{
          height: 80,
          display: 'flex',
          alignItems: 'center',
          padding: '0 20px',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {logo && (
          <img
            src={logo || `/media/logos/bank-log.png`}
            alt='Bank Logo'
            style={{ height: 60, width: 'auto', objectFit: 'contain' }}
          />
        )}
      </div>

      {/* Scrollable menu body */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
    </Drawer>
  )
}

export { AsideDefault }
